import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Password dimenticata" subtitle="Ti invieremo un link valido 1 ora per reimpostarla." testId="forgot-page">
      {sent ? (
        <div className="rounded-2xl bg-[#E8EEF8] p-5 text-sm text-[#0F2D5E]" data-testid="forgot-success">
          <MailCheck className="mb-2 h-6 w-6" />
          Se l'email è registrata riceverai a breve un link per reimpostare la password. Controlla anche la cartella spam.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required className="h-12" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </div>
          {error && <p className="text-sm text-red-700" data-testid="forgot-error">{error}</p>}
          <Button type="submit" disabled={loading} className="h-12 w-full rounded-full bg-[#0F2D5E] hover:bg-[#0B2250]" data-testid="forgot-submit-btn">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Invia link
          </Button>
        </form>
      )}
      <p className="mt-6 text-center text-sm"><Link to="/accedi" className="font-semibold text-[#0F2D5E] hover:underline" data-testid="back-login-link">Torna all'accesso</Link></p>
    </AuthShell>
  );
}
